import cn from 'clsx'

// Components
import { IconRow } from 'kit'
import DisabledOverlay from 'components/track/disabledoverlay'
import CoverArt from 'components/coverart'

// Hooks
import { useArtists } from 'modules/entities/hooks'

// Types
import { Song } from 'types'

// Utils
import { ArtistsAsString } from 'components/track/artists'

type MiniSongProps = {
  song: Song
  className?: string
  rightComponent?: JSX.Element
  onClick?: (arg: unknown) => unknown
  isDisabled?: boolean
}

const MiniSong = (props: MiniSongProps): JSX.Element => {
  const { song, className, rightComponent, onClick, isDisabled } = props
  const allArtists = useArtists()
  const artists = song?.artists.map(artistId => allArtists[String(artistId)])
  return (
    <div>
      <IconRow
        title={song.title}
        hoverTitle={song.title}
        iconComponent={<CoverArt cover={song.cover} />}
        description={ArtistsAsString(artists, song.genres)}
        className={cn(className)}
        rightComponent={rightComponent}
        key={song.id}
        onClick={onClick}
      />
      {isDisabled && <DisabledOverlay />}
    </div>
  )
}

export default MiniSong
